<div class="" [ngClass]="{'p-3' : label}">
    <div class="flex justify-content-between" *ngIf="label">
        <h5>{{shared_service.account_cost_heading}}</h5>
    </div>
    <hr *ngIf="label">
    <form class="grid" [formGroup]="jobs_expense_form">
        <div class="col-12 lg:col-12">
            <div class="grid formgrid p-fluid">
                <div class="field col-12 md:col-12">
                    <label for="multiplemonths">{{translate_service.getText('lbl_date')}}<span class="asterisk">
                            *</span></label>
                    <p-calendar [dateFormat]="shared_service.date_format_input_code" formControlName="date"
                        [placeholder]="shared_service.date_format_code" [(ngModel)]="selectedStartDate"
                        [showTime]="false"
                        [ngClass]="{'is-invalid ng-dirty': jobs_expense_form.get('date').invalid && (jobs_expense_form.get('date').dirty || jobs_expense_form.get('date').touched || jobs_expense_form.submitted)}"></p-calendar>
                    <span
                        *ngIf="jobs_expense_form.get('date').invalid && (jobs_expense_form.get('date').dirty || jobs_expense_form.get('date').touched || jobs_expense_form.submitted)">
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('date').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('date').errors?.incorrect">{{error_message
                            }}</small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12" *ngIf="label || url?.includes('clients')">
                    <label>{{translate_service.getText('lbl_staff')}}<span class="asterisk"> *</span></label>
                    <p-dropdown optionValue="user_profile_id" optionLabel="name" [options]="user_list" [filter]="true"
                        [resetFilterOnHide]="true"
                        [ngClass]="{'is-invalid':jobs_expense_form.get('staff_id').invalid &&  
                        (jobs_expense_form.get('staff_id').touched || jobs_expense_form.get('staff_id').dirty || jobs_expense_form.submitted)}"
                        formControlName="staff_id" placeholder="{{translate_service.getText('message_135')}}"></p-dropdown>
                    <span
                        *ngIf="jobs_expense_form.get('staff_id').invalid && (jobs_expense_form.get('staff_id').dirty ||jobs_expense_form.get('staff_id').touched ||jobs_expense_form.submitted )">
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('staff_id').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('staff_id').errors?.incorrect">{{error_message
                            }}</small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12" *ngIf="!label && !url?.includes('clients')">
                    <label>{{translate_service.getText('lbl_staff')}}<span class="asterisk"> *</span></label>
                    <p-dropdown optionValue="staff_id" optionLabel="name" [options]="user_list" [filter]="true"
                        [resetFilterOnHide]="true"
                        [ngClass]="{'is-invalid':jobs_expense_form.get('staff_id').invalid &&  
                        (jobs_expense_form.get('staff_id').touched || jobs_expense_form.get('staff_id').dirty || jobs_expense_form.submitted)}"
                        formControlName="staff_id" placeholder="{{translate_service.getText('message_135')}}"></p-dropdown>
                    <span
                        *ngIf="jobs_expense_form.get('staff_id').invalid && (jobs_expense_form.get('staff_id').dirty ||jobs_expense_form.get('staff_id').touched ||jobs_expense_form.submitted )">
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('staff_id').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('staff_id').errors?.incorrect">{{error_message
                            }}</small>
                    </span>
                </div>
                <div class="field col-12 md:col-12">
                    <label for="client_id" class="font-medium text-900">{{translate_service.getText('lbl_client')}}<span
                            class="asterisk">*</span>
                    </label>
                    <p-dropdown optionValue="client_id" optionLabel="name" formControlName="client_id"
                        [options]="client_list" placeholder="{{translate_service.getText('message_119')}}"
                        [filter]="true" dropzone="true"  [ngClass]="{
                            'is-invalid': jobs_expense_form.get('client_id').invalid && (jobs_expense_form.get('client_id').dirty || jobs_expense_form.get('client_id').touched || jobs_expense_form.submitted),
                            }" (ngModelChange)="ClientChanged()">
                    </p-dropdown>
                    <span
                        *ngIf="jobs_expense_form.get('client_id').invalid && (jobs_expense_form.get('client_id').dirty || jobs_expense_form.get('client_id').touched || jobs_expense_form.submitted)">
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('client_id').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('client_id').errors?.incorrect">{{error_message}}</small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12">
                    <label>{{translate_service.getText('lbl_jobs')}}<span class="asterisk"> *</span></label>
                    <p-dropdown optionValue="job_id" [resetFilterOnHide]="true" optionLabel="name" [options]="jobs_list"
                        [filter]="true"
                        [ngClass]="{'is-invalid': jobs_expense_form.get('job_id').invalid &&  
                        (jobs_expense_form.get('job_id').touched || jobs_expense_form.get('job_id').dirty || jobs_expense_form.submitted)}"
                        formControlName="job_id" placeholder="{{translate_service.getText('lbl_select_job')}}">
                    </p-dropdown>
                    <span
                        *ngIf="jobs_expense_form.get('job_id').invalid && 
                        (jobs_expense_form.get('job_id').dirty || jobs_expense_form.get('job_id').touched || jobs_expense_form.submitted)">
                        <small class="alert-danger" *ngIf="jobs_expense_form.get('job_id').errors?.required">
                            {{translate_service.getText('message_25')}}
                        </small>
                        <small class="alert-danger" *ngIf="jobs_expense_form.get('job_id').errors?.incorrect">
                            {{error_message}}
                        </small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12">
                    <label class="font-medium text-900">{{shared_service.account_cost_heading}}<span
                            class="asterisk">*</span></label>
                    <p-dropdown [options]="cost_list" placeholder="{{translate_service.getText('lbl_select')}} {{shared_service.account_cost_heading}}"
                        optionValue="cost_id" optionLabel="name" formControlName="cost_id" [filter]="true"
                        (onChange)="costChange()" dropzone="true" [ngClass]="{
                            'is-invalid': jobs_expense_form.get('cost_id').invalid && (jobs_expense_form.get('cost_id').dirty || jobs_expense_form.get('cost_id').touched),
                            }"></p-dropdown>
                    <span
                        *ngIf="jobs_expense_form.get('cost_id').invalid && (jobs_expense_form.get('cost_id').dirty || jobs_expense_form.get('cost_id').touched || jobs_expense_form.submitted)">
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('cost_id').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('cost_id').errors?.incorrect">{{error_message}}</small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12">
                    <label class="font-medium text-900"> {{translate_service.getText('lbl_unit_cost')}}<span
                            class="asterisk">*</span></label>
                    <p-inputNumber formControlName="unit_cost"
                        [placeholder]="translate_service.getText('message_169')"
                        [minFractionDigits]="shared_service.maxFractionDigits"
                        [maxFractionDigits]="shared_service.maxFractionDigits" mode="currency"
                        [currency]="shared_service.iso_code" [locale]="shared_service.iso_locale" />
                    <span
                        *ngIf="jobs_expense_form.get('unit_cost').invalid && (jobs_expense_form.get('unit_cost').dirty || jobs_expense_form.get('unit_cost').touched || jobs_expense_form.submitted)">
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('unit_cost').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('unit_cost').errors?.incorrect">{{error_message}}</small>
                    </span>
                </div>

                <div class="field mb-4 col-12 md:col-12">
                    <label class="font-medium text-900"> {{translate_service.getText('lbl_unit_price')}}<span
                            class="asterisk">*</span></label>
                    <p-inputNumber formControlName="unit_price"
                        [placeholder]="translate_service.getText('message_170')"
                        [minFractionDigits]="shared_service.maxFractionDigits"
                        [maxFractionDigits]="shared_service.maxFractionDigits" mode="currency"
                        [currency]="shared_service.iso_code" [locale]="shared_service.iso_locale" />

                    <span
                        *ngIf="jobs_expense_form.get('unit_price').invalid && (jobs_expense_form.get('unit_price').dirty || jobs_expense_form.get('unit_price').touched || jobs_expense_form.submitted)">
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('unit_price').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('unit_price').errors?.incorrect">{{error_message}}</small>
                    </span>
                </div>

                <div class="field mb-4 col-12 md:col-12">
                    <label class="font-medium text-900">{{translate_service.getText('lbl_quantity')}}<span
                            class="asterisk">*</span></label>
                    <input type="text" pInputText pKeyFilter="num" formControlName="quantity"
                        placeholder="{{translate_service.getText('message_130')}}"
                        [ngClass]="{'ng-invalid ng-dirty': jobs_expense_form.get('quantity').invalid && (jobs_expense_form.get('quantity').dirty || jobs_expense_form.get('quantity').touched || jobs_expense_form.submitted)}" />
                    <span
                        *ngIf="jobs_expense_form.get('quantity').invalid && (jobs_expense_form.get('quantity').dirty || jobs_expense_form.get('quantity').touched || jobs_expense_form.submitted)">
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('quantity').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('quantity').errors?.incorrect">{{error_message}}</small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12">
                    <label for="cost_sell_type_id"
                        class="font-medium text-900">{{translate_service.getText('lbl_type')}}<span
                            class="asterisk">*</span></label>
                    <p-dropdown [options]="cost_type_list" formControlName="cost_sell_type_id" optionLabel="name"
                        [filter]="false" dropzone="true" optionValue="cost_sell_type_id" [ngClass]="{
                            'is-invalid': jobs_expense_form.get('cost_sell_type_id').invalid && (jobs_expense_form.get('cost_sell_type_id').dirty || jobs_expense_form.get('cost_sell_type_id').touched),
                            }">
                    </p-dropdown>
                    <span
                        *ngIf="jobs_expense_form.get('cost_sell_type_id').invalid && (jobs_expense_form.get('cost_sell_type_id').dirty || jobs_expense_form.get('cost_sell_type_id').touched || jobs_expense_form.submitted)">
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('cost_sell_type_id').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('cost_sell_type_id').errors?.incorrect">{{error_message}}</small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12">
                    <label class="font-medium text-900">{{translate_service.getText('lbl_code')}}</label>
                    <input placeholder="{{translate_service.getText('message_65')}}" formControlName="code"
                        type="text" pInputText>
                    <span>
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('code').errors?.incorrect">{{error_message}}</small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12">
                    <label class="font-medium text-900">{{translate_service.getText('lbl_description')}}</label>
                    <textarea [placeholder]="translate_service.getText('message_63')" formControlName="description"
                        type="text" pInputTextarea rows="5" [autoResize]="true"></textarea>
                    <span>
                        <small class="alert-danger"
                            *ngIf="jobs_expense_form.get('description').errors?.incorrect">{{error_message}}</small>
                    </span>
                </div>
                <div class="field col-12 md:col-6">
                    <div class="field-checkbox">
                        <p-checkbox formControlName="is_billable" [binary]="true"></p-checkbox>
                        <label>{{translate_service.getText('lbl_billable')}}</label>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <div class="field-checkbox">
                        <p-checkbox formControlName="is_actual" [binary]="true"></p-checkbox>
                        <label class="font-medium text-900">{{translate_service.getText('lbl_actual')}}</label>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="flex gap-2 justify-content-end">
        <button type="button" pButton pRipple icon="pi pi-trash" label="{{translate_service.getText('lbl_delete')}}"
            class="p-element p-ripple p-button-danger p-button-outlined mr-2 p-button p-component" (click)="onDeletecost()"
            *ngIf="this.form_mode == this.formMode.Edit"></button>
        <button pButton pRipple type="button" icon="pi pi-times" label="Cancel"
            class="p-element p-ripple p-button-outlined mr-2 p-button" (click)="onCancel('')"></button>
        <button pButton pRipple label="Save" icon="pi pi-check" type="submit"[disabled]="cost_details?.status_id === 4"
            class="p-element p-ripple p-button-primary  p-button" (click)="onSave()"></button>
    </div>
</div>